import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import {HeaderSection} from './HeaderSection';
import {TechnicalsData} from './TechnicalsData';

interface Props {
  changeView: () => void;
}

export const Technicals = observer(({changeView}: Props) => {
  return <Wrapper>
    <HeaderSection changeView={changeView}/>
    <DataContainer>
      <TechnicalsData />
    </DataContainer>
  </Wrapper>;
});

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const DataContainer = styled.div`
  height: auto;
  overflow-y: auto;

  // For Internet Explorer
    scrollbar-face-color: rgba(138,138,138,0.32);
    scrollbar-track-color: rgba(138,138,138,0.12);

    // For Google Chrome
    &::-webkit-scrollbar {
      height: 5px;
      width: 5px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: rgba(138,138,138,0.32);
    }
  
    &::-webkit-scrollbar-track {
      background: rgba(138,138,138,0.12);
    }
`;
